export default state => {
  const arborescence = state.vod.hodor.authenticate.arborescence;

  if (arborescence.length) {
    return arborescence[0].onClick.path;
  }

  return '/chaines';
};
